import { createLogger, LogLevel } from './utils/logger';
import state from './core/state';
import api from './core/api';
// @ts-ignore
import modalManager from './ui/modal/manager';
import tariffModalEvents from './ui/tariff/events';
import { createTariffModal } from './templates/tariff-modal';
import { createTariffModalMob } from './templates/tariff-modal-mob';
import { initTariffSwiper, initTariffCompareSwiper } from './utils/swiper-integration';
import { TariffComparison } from './utils/tariff-comparison';

const logger = createLogger('CatalogModalsEntry', LogLevel.INFO);

// Глобальный обработчик для открытия тарифной модалки
function handleTariffModalOpen(e: Event) {
  const target = e.target as HTMLElement;
  if (!target) return;
  // Ищем ближайший элемент с data-action="open-tariff-modal"
  const btn = target.closest('[data-action="open-tariff-modal"]') as HTMLElement;
  if (!btn) return;
  const courseId = btn.getAttribute('data-course-id');
  if (!courseId) {
    logger.warn('Не указан data-course-id для открытия тарифной модалки');
    return;
  }
  logger.info(`Открытие тарифной модалки для курса #${courseId}`);
  // @ts-ignore
  api.getRawCourseById(courseId).then((rawCourse: any) => {
    logger.info('RAW ответ API на getRawCourseById:', rawCourse);
    if (!rawCourse) {
      logger.error('Курс не найден по id:', courseId);
      return;
    }
    const isMobile = window.innerWidth < 768;
    const modalContent = isMobile ? createTariffModalMob(rawCourse) : createTariffModal(rawCourse);
    modalManager.openModal(modalContent);
    

    if (typeof (window as any).getShopCoursesById === 'function') {
      try {
        (window as any).getShopCoursesById();

        logger.info('Вызвана функция getShopCoursesById() при открытии модалки');
      } catch (error) {
        logger.error('Ошибка при вызове getShopCoursesById():', error);
      }
    } else {
      logger.warn('Функция getShopCoursesById() не найдена в window');
    }
    
    // Получаем актуальный контейнер модалки из DOM
    const actualModalContent = modalManager.getModalContent();
    if (!actualModalContent) {
      logger.error('Не удалось получить modalContent после открытия модалки');
      return;
    }

    // Инициализация аккордеона и сравнения тарифов
    new TariffComparison(actualModalContent);

    // Инициализируем свайперы для мобильных устройств только если есть тарифы и структура DOM валидна
    if (isMobile && rawCourse.tariffs && Array.isArray(rawCourse.tariffs) && rawCourse.tariffs.length > 0) {
      const swiperContainer = actualModalContent.querySelector('.tariff__items.swiper');
      const swiperWrapper = swiperContainer?.querySelector('.swiper-wrapper');
      const slides = swiperWrapper?.querySelectorAll('.swiper-slide');
      if (swiperContainer && swiperWrapper && slides && slides.length > 0) {
        initTariffSwiper(actualModalContent);
      } else {
        logger.warn('Не инициализируем тарифный Swiper: невалидная структура DOM или нет слайдов');
      }
      const compareContainer = actualModalContent.querySelector('.tariff__compare.swiper');
      const compareWrapper = compareContainer?.querySelector('.swiper-wrapper');
      const compareSlides = compareWrapper?.querySelectorAll('.swiper-slide');
      if (compareContainer && compareWrapper && compareSlides && compareSlides.length > 0) {
        initTariffCompareSwiper(actualModalContent);
      } else {
        logger.warn('Не инициализируем Swiper сравнения: невалидная структура DOM или нет слайдов');
      }
    }

    // Навешиваем события только на актуальный контейнер
    tariffModalEvents.bindEvents();
  }).catch((err: any) => {
    logger.error('Ошибка при получении курса для модалки:', err);
  });
}

document.addEventListener('click', handleTariffModalOpen);

logger.info('catalog-modals entry point инициализирован');

export {
  state,
  api,
  modalManager,
  tariffModalEvents,
  createLogger,
  LogLevel,
  initTariffSwiper,
  initTariffCompareSwiper
};
